﻿window.myApp = angular.module('myApp', []);
require("./controllers/app");
(function (x) {
    window.checkLang = function () {
        var lang = false;
        if (x("body").hasClass("heb")) {
            lang = true;
        }
        return lang;
    }
    var maxViewport = {
        mobile: 992,
        desktop: 2480
    }

    //form validation
    require("./form");
    if (x("body").hasClass("yit-home-page")) {// 
        $("#latest-projects-section figure img").on("click", function (e) {

            var ref = $(this).parent().find("h5 a").attr("href");
            location.href = ref
        })
    }
 
 

 
    /* slider */
    x('#tabs-links a').click('click', function (e) {
        e.preventDefault();

        x(this).parent().find('.active').removeClass('active');
        x(this).addClass('active');

        var eq = x(this).data('slide-index');
        x('#indicator #dot').removeClass().addClass('item-' + eq);
    });

    if (typeof $.fn.slick !== 'undefined') {

        // homepage's carousel right side
        x('#tabs-content').slick({
            infinite: true,
            arrows: false,
            slidesToShow: 1,
            responsive: [{
                breakpoint: maxViewport.desktop,
                settings: {
                    verticalSwiping: true,
                    vertical: true,
                }
            }, {
                breakpoint: maxViewport.mobile,
                settings: {
                    vertical: false,
                    verticalSwiping: false
                }

            }]
        });

        // homepage's carousel dots
        x('a[data-slide-index]').click(function (e) {
            e.preventDefault();
            var slideno = x(this).data('slide-index');
            x('#tabs-content').slick('slickGoTo', slideno - 1);
            x('#tabs-links').slick('slickGoTo', slideno - 1);
        });

        // homepage's carousel left side
        x('#tabs-links').slick({
            responsive: [
                    {
                        breakpoint: maxViewport.mobile,
                        settings: {
                            arrows: false,
                            //slidesToShow: 3,
                            slidesToScroll: 1,
                            infinite: true,
                            centerMode: true,
                            centerPadding: '0',
                            variableWidth: true,
                        }
                    }, {
                        breakpoint: maxViewport.desktop,
                        settings: "unslick"
                    }
            ]
        }
        );

        // project page carousel
        x('#project-footer').slick({
            slidesToShow: 4,
            prevArrow: ".custom-prev",
            nextArrow: ".custom-next",
            responsive: [
                {
                    breakpoint: maxViewport.mobile,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        centerPadding: '40px',
                        //variableWidth: true,
                    }
                }
            ]
        });

        // article page
        x('#article-footer').slick({
            centerMode: true,
            centerPadding: '40px',
            //variableWidth: true,
            slidesToShow: 3,
            prevArrow: ".custom-prev",
            nextArrow: ".custom-next",
            responsive: [
                {
                    breakpoint: maxViewport.mobile,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        centerPadding: '40px',
                        //variableWidth: true,
                    }
                }
            ]
        });


        // homepage's bottom carousel
        x('.carousel-quotes').slick({
            infinite: true,
            arrows: true,
            slidesToShow: 1,
            prevArrow: "#slider-prev",
            nextArrow: "#slider-next",
        });
    }
 
})
(jQuery);

 


//////////////////
// WEBPACK FOOTER
// ../scripts/yit/main.js
// module id = 6
// module chunks = 0